<template>
  <v-card class="mb-4">
    <v-card-title>
      <div class="d-flex align-center">
        {{ selectedItem }}
        <v-tooltip :text="tooltip" location="top" v-if="tooltip && tooltip.length > 0">
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              icon="mdi-information"
              size="small"
              class="ml-2"
            ></v-icon>
          </template>
        </v-tooltip>
        <v-select
          v-model="selected"
          :items="items"
          variant="plain"
          hide-details
          class="select-hidden"
          @update:modelValue="handleSelectionChange"
        ></v-select>
      </div>
    </v-card-title>
    <v-card-text class="text-h3">
      {{ displayCount }}
    </v-card-text>
  </v-card>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
